import React from 'react';
import Link from 'next/link';
import cn from 'classnames';

const NavItem = ({ title, href, color }) => (
  <li className="relative py-2 lg:p-0 lg:mr-6 last:mr-0">
    <Link
      href={href}
      className={cn(
        'font-normal text-sm lg:text-sm leading-5 block select-none cursor-pointer transition-all duration-300 hover:text-opacity-75',
        color
      )}>

      {title}

    </Link>
  </li>
);

export default NavItem;
